// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__17jNn","left":"InfoRow_left__aBBkR"};